import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { Col, Row, Select, Skeleton, Table } from "antd";
import "./index.css";
import { DownloadOutlined, PrinterFilled } from "@ant-design/icons";
// import { useHistory } from "react-router";
import { BiCalendar } from "react-icons/bi";
import { loadStockList } from "../../store/items/actions";
import { itemHeaderData } from "./data";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
// import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
// import ReactToPrint from "react-to-print";
// import Spinner from "../../components/spinner/Spinner";

const Transactions = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [selectDays, setSelectDays] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [downloadLoading, setDownloadLoading] = useState(false);
  // const [mouseEnter, setMouseEnter] = useState(false);
  // const contentStyle = {
  //   padding: 50,
  //   background: "rgba(0, 0, 0, 0.05)",
  //   borderRadius: 4,
  // };
  // const content = <div style={contentStyle} />;
  //organisation id from login response
  const itemListId = {
    organizationId: props.organizationId,
    itemId: props.itemId,
  };

  //api loader
  useEffect(() => {
    dispatch(loadStockList(itemListId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { stock_details = [] } = useSelector((state) => state.Items);

  const tableData =
    stock_details && stock_details.length > 0
      ? stock_details.map((data, index) => {
          return {
            index: index + 1,
            quantity: data.Quantity,
            closingStock: data.closingStock,
            date: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "-",
            itemId: data.itemId,
            organizationId: data.organizationId,
            serialIds: data.serialIds,
            invoiceNumber: data.invoiceNumber ? data.invoiceNumber : "--",
            transactionType: data.transactionType,
            updatedAt: data.updatedAt
              ? moment(data.updatedAt).format("DD-MM-YYYY")
              : "-",
            _id: data._id,
          };
        })
      : [];

  //Download functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const exportToCsv = () => {
    // setDownloadLoading(true);

    const tableExportData =
      stock_details && stock_details.length > 0
        ? stock_details.map((data, index) => {
            return {
              index: index + 1,
              quantity: data.Quantity,
              closingStock: data.closingStock,
              date: data.createdAt
                ? moment(data.createdAt).format("DD-MM-YYYY")
                : "-",
              itemId: data.itemId,
              organizationId: data.organizationId,
              serialIds: data.serialIds,
              invoiceNumber: data.invoiceNumber ? data.invoiceNumber : "--",
              transactionType: data.transactionType,
              updatedAt: data.updatedAt
                ? moment(data.updatedAt).format("DD-MM-YYYY")
                : "-",
              _id: data._id,
            };
          })
        : [];
    setTimeout(() => {
      let headerData = [
        "Date, Transaction Type, Quantity, Invoice Number, Closing Stock",
      ];

      let usersCsv = !isEmpty(tableExportData)
        ? tableExportData.reduce((acc, user) => {
            const {
              date,
              transactionType,
              quantity,
              invoiceNumber,
              closingStock,
            } = user;
            acc.push([
              date,
              transactionType,
              quantity,
              invoiceNumber,
              closingStock,
            ]);

            console.log("test", acc);
            return acc;
          }, [])
        : false;
      console.log(usersCsv, "usersCsv");

      const usersList =
        !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : [];

      downloadFile({
        data: [...headerData, ...usersList].join("\n"),
        fileName: "ItemStockDetails.csv",
        fileType: "text/csv",
      });
      // setDownloadLoading(false);
    }, 2500);
  };

  console.log(stock_details, "stock_details");

  // const componentRef = useRef();

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Items | Mbook</title>
        </MetaTags>
      </div>
      {/* {downloadLoading === true ? ( */}
      {/* <div>
        <Spin
          className="m-[20%] bg-[#ffffff]"
          tip="Loading"
          size="large"
        ></Spin>
      </div> */}
      {/* ) : (
        ""
      )} */}
      <Row
        // onMouseEnter={() => setMouseEnter(true)}
        // onMouseLeave={() => setMouseEnter(false)}
        // className={mouseEnter ? "items-stocks-menu-main-card border-solid rounded-sm bg-[#ffffff]" : "border-solid rounded-sm bg-[#ffffff]"}
        className={"border-solid rounded-sm bg-[#ffffff]"}
      >
        <Col span={24}>
          <Row
            className={
              loading ? "flex justify-between pr-4" : "flex justify-between"
            }
          >
            <Col span={6} className="mr-3">
              {loading ? (
                <Skeleton.Input className="w-[100%]"></Skeleton.Input>
              ) : (
                <Select
                  suffixIcon={<BiCalendar size={16} />}
                  placeholder="Select Days"
                  value={selectDays}
                  onChange={(e) => setSelectDays(e)}
                  className="h-[40px] w-[100%]"
                />
              )}
            </Col>

            <Col span={8}>
              <Row className="flex">
                <Col span={12} className="pr-3 cursor-pointer">
                  {loading ? (
                    <Skeleton.Input className="w-[100%] mr-2"></Skeleton.Input>
                  ) : (
                    <div
                      onClick={() => exportToCsv()}
                      className="flex border p-2 rounded-md border-1 text-center"
                    >
                      <DownloadOutlined className="text-[16px] mr-3" /> Download
                    </div>
                  )}
                </Col>
                <Col span={12} className="pr-3 cursor-pointer">
                  {loading ? (
                    <Skeleton.Input className="w-[100%]"></Skeleton.Input>
                  ) : (
                    <div
                      // onClick={() => {
                      //   let objFra = document.getElementById("myFrame");

                      //   objFra.content.print();
                      // }}
                      className="flex border p-2 rounded-md  border-1 text-center"
                    >
                      <PrinterFilled className="text-[16px] mr-3" /> Print PDF
                      {/* <ReactToPrint
                        trigger={() => <button>Print PDF</button>}
                        content={() => componentRef.current}
                      /> */}
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24} className="mt-4 mb-[70px]">
          <div>
            <Table
              style={{
                overflow: "hidden",
                cursor: "pointer",
              }}
              bordered
              columns={itemHeaderData}
              dataSource={tableData}
              sortDirections={"ascend"}
              id="myFrame"
              // ref={componentRef}
              loading={loading ? true : false}
              showSorterTooltip={"sorter-icon"}
              // onRow={partiesRoutes}
              // rowHoverable={partiesRoutes}
              // sticky=""

              // rowSelection={{
              //   type: selectionType,
              //   ...rowSelection,
              // }}
              // rowSelection={true}
              // rowSelection={partiesRoutes}
              scroll={{ y: 210 }}
            />
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

Transactions.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
};

export default Transactions;
